// extracted by mini-css-extract-plugin
export var comments = "styles-module--comments--e5643";
export var content = "styles-module--content--339d2";
export var count = "styles-module--count--d072a";
export var description = "styles-module--description--330d0";
export var fixed = "styles-module--fixed--c4d4d";
export var head = "styles-module--head--1d0a4";
export var headContent = "styles-module--headContent--9ddd3";
export var share = "styles-module--share--5e981";
export var tag = "styles-module--tag--86df0";
export var tags = "styles-module--tags--93cd6";
export var title = "styles-module--title--b8233";
export var wrapper = "styles-module--wrapper--ec95b";